import { cleanParamsByService, findInSwaggerWhiteList, transformRequest } from 'api/helpers/utils';
import { removeServicesParams, SWAGGER_ENDPOINTS_TRANSFORM_REQUEST } from 'api/helpers/whiteList';

export default apiCall => {
  apiCall.interceptors.request.use(async req => {
    if (findInSwaggerWhiteList(SWAGGER_ENDPOINTS_TRANSFORM_REQUEST, req.url)) {
      transformRequest(req, req.url);
    }

    req.params = cleanParamsByService(req.url, req.params, removeServicesParams.params);
    req.headers = cleanParamsByService(req.url, req.headers, removeServicesParams.headers);

    return req;
  });
};
